"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromocodeTypes = void 0;
var PromocodeTypes;
(function (PromocodeTypes) {
    PromocodeTypes["REGULAR"] = "REGULAR";
    PromocodeTypes["LIMITED"] = "LIMITED";
    PromocodeTypes["ONE_TIME"] = "ONE_TIME";
})(PromocodeTypes || (exports.PromocodeTypes = PromocodeTypes = {}));
//# sourceMappingURL=promocode-types.enum.js.map